import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY } from '@sortlist-frontend/design-system/legacy';

type SliderButtonProps = {
  direction: 'back' | 'forward';
};

export const SliderButton = styled.div`
  position: absolute;
  top: 50%;
  z-index: 3000;

  ${(props: SliderButtonProps) =>
    props.direction === 'back' &&
    `left: 0.5rem;

    @media only screen and (min-width: ${BREAKPOINTS_LEGACY.xs}) {
      left: 20px;
    }`}
  ${(props: SliderButtonProps) =>
    props.direction === 'forward' &&
    `right: 0.5rem;

    @media only screen and (min-width: ${BREAKPOINTS_LEGACY.xs}) {
      right: 20px;
    }`}
`;
